<template>

    <div class="sdev-wizard-template">

        <h2>Select Template</h2>

        <div v-for="t in templates" :key="t.template_key" class="sdev-wizard-template-card"
            @click="emit('select', t.template_key)">

            <div class="title">
                {{ t.template.template_name }}
            </div>

            <div class="meta">
                {{ t.template.template_key }}
            </div>

        </div>

    </div>

</template>

<script setup>

const props = defineProps({
    templates: Array
})

const emit = defineEmits(["select"])

</script>
